module.exports = __webpack_public_path__ + "site/img/index3-sd.741783fa.png";